import React from "react";
import DaoHero from "./daoHero";
import DaoMembers from "./daoMembers";
export default function Dao() {
  return (
    <div>
      <DaoHero />
      <DaoMembers />
    </div>
  );
}
